var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 23.5V28C13 29.104 13.896 30 15 30C16.104 30 17 29.104 17 28V23.5C17 22.396 16.104 21.5 15 21.5C13.896 21.5 13 22.396 13 23.5ZM19.616 22.414L22.616 25.414C23.396 26.195 24.664 26.195 25.444 25.414C26.225 24.634 26.225 23.366 25.444 22.586L22.444 19.586C21.664 18.805 20.396 18.805 19.616 19.586C18.835 20.366 18.835 21.634 19.616 22.414ZM7.496 19.586L4.556 22.526C3.775 23.306 3.775 24.574 4.556 25.354C5.336 26.135 6.604 26.135 7.384 25.354L10.324 22.414C11.105 21.634 11.105 20.366 10.324 19.586C9.544 18.805 8.276 18.805 7.496 19.586ZM2 17H6.5C7.604 17 8.5 16.104 8.5 15C8.5 13.896 7.604 13 6.5 13H2C0.896 13 0 13.896 0 15C0 16.104 0.896 17 2 17ZM23.5 17H28C29.104 17 30 16.104 30 15C30 13.896 29.104 13 28 13H23.5C22.396 13 21.5 13.896 21.5 15C21.5 16.104 22.396 17 23.5 17ZM10.414 7.586L7.414 4.586C6.634 3.805 5.366 3.805 4.586 4.586C3.805 5.366 3.805 6.634 4.586 7.414L7.586 10.414C8.366 11.195 9.634 11.195 10.414 10.414C11.195 9.634 11.195 8.366 10.414 7.586ZM22.414 10.414L25.474 7.354C26.255 6.574 26.255 5.306 25.474 4.526C24.694 3.745 23.426 3.745 22.646 4.526L19.586 7.586C18.805 8.366 18.805 9.634 19.586 10.414C20.366 11.195 21.634 11.195 22.414 10.414ZM13 2V6.5C13 7.604 13.896 8.5 15 8.5C16.104 8.5 17 7.604 17 6.5V2C17 0.896 16.104 0 15 0C13.896 0 13 0.896 13 2Z",
    fill: "#009BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.8398dd7b71077476da0e2a15f0656bc2.svg";
export { ForwardRef as ReactComponent };